import { appStore } from '@/store';
import { apolloClient } from '@/lib/apollo';
import { features, getLocale, getToken } from '@/lib';
import {
  ADDRESS_NORMALIZATION_QUERY,
  NORMALIZED_ADDRESSES_QUERY,
} from './graphql/queries';
import { isANSResponseAlreadyNormalized, mapANSRequest } from './mapper';
import { logger } from '@/lib/logger';
import { logFPTIForANSApi } from './fpti';

export const isAddressNormalized = (): Promise<boolean> => {
  const { ui: uiActions } = appStore.getActions();
  const token = getToken();
  // suppose to be billing country
  const { country } = getLocale();

  // map request payload for AU and BR
  const payload = mapANSRequest(country);
  const hasAddressNormalizationBoth = features.isActive(
    'hasAddressNormalizationBoth',
  );

  logFPTIForANSApi('prepare');
  return apolloClient
    .query({
      query: hasAddressNormalizationBoth
        ? NORMALIZED_ADDRESSES_QUERY
        : ADDRESS_NORMALIZATION_QUERY,
      variables: { token, ...payload },
    })
    .then(response => {
      const alreadyNormalized = isANSResponseAlreadyNormalized(
        country,
        response,
      );
      // if the address already normalized, address normalization is
      // not required.
      if (alreadyNormalized) {
        logFPTIForANSApi('process', { alreadyNormalized: 1 });
        logger.info('Address_already_normalized', { country });
        return true;
      }
      logFPTIForANSApi('process', { alreadyNormalized: 0 });
      logger.info('Address_is_not_normalized', { country });
      uiActions.toggleIsAddressNormalizeOpen(true);
      return false;
    })
    .catch(error => {
      logFPTIForANSApi('process', { int_error_code: 'ans_api_error' });
      logger.info('address_normalization_error', { error });

      // Since address normalization isn't critical to complete the transaction,
      // if the call errors out we continue on without doing normalization.
      return true;
    });
};
